// Return Age given birthday date.
// 1937-03-01T00:00:00.000Z -> 84 years
export const getAgeFromDate = (birthDate: string) =>
    Math.floor(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ((new Date() as any) - new Date(birthDate).getTime()) / 3.15576e10
        // 31557600000 = 24 * 3600 * 365.25 * 1000 which is the length of a year
    );
